import { useTranslation } from 'react-i18next';
import {
  ReactCompareSlider,
  ReactCompareSliderHandle,
  ReactCompareSliderImage,
} from 'react-compare-slider';
import { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { externalLinks } from '@/config';
import { Button, ModalDefault, ModalDefaultProps } from '@/components';
import { useOpenChat } from '@/hooks';

import logoAMLBot from '@/assets/images/logo-amlbot.svg';
import previewProPlus from '@/assets/images/modals/compareReports/proPlus.webp';
import previewLite from '@/assets/images/modals/compareReports/lite.webp';

import { buttonStyle, lineStyle } from './CompareReportsModal.constants';
import styles from './CompareReportsModal.module.sass';

interface CompareReportsModalProps extends ModalDefaultProps {
  isOpen: boolean;
  onClose: () => void;
}

const CompareReportsModal = ({
  isOpen,
  onClose,
}: CompareReportsModalProps): JSX.Element => {
  const { t } = useTranslation();
  const [position, setPosition] = useState(50);
  const { handleOpenChat } = useOpenChat();

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        setPosition(80);

        setTimeout(() => {
          setPosition(20);

          setTimeout(() => {
            setPosition(50);
          }, 1000);
        }, 1000);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  return (
    <ModalDefault isOpen={isOpen} className={styles.modal} onClose={onClose}>
      <div className={styles.content}>
        <img src={logoAMLBot} alt="AMLBot" className={styles.logo} />

        <h3 className={styles.title}>{t('translation.compare_plan_title')}</h3>

        <div className={styles.list}>
          {parse(t('translation.compare_plan_list'))}
        </div>

        <div className={styles.actions}>
          <Button
            type="primary-black"
            size="m"
            corner="rect"
            className={styles.button}
            onClick={handleOpenChat}
          >
            {t('translation.upgrade_pro_plus_btn')}
          </Button>
        </div>
      </div>

      <div className={styles.compare}>
        <h3 className={styles.title}>
          {t('translation.compare_reports_title')}
        </h3>

        <div className={styles.preview}>
          <ReactCompareSlider
            position={position}
            transition=".75s ease-in-out"
            handle={
              <ReactCompareSliderHandle
                linesStyle={lineStyle}
                buttonStyle={buttonStyle}
              />
            }
            itemOne={
              <ReactCompareSliderImage
                src={previewLite}
                srcSet={previewLite}
                alt="Lite"
              />
            }
            itemTwo={
              <ReactCompareSliderImage
                src={previewProPlus}
                srcSet={previewProPlus}
                alt="Pro+"
              />
            }
            onPositionChange={setPosition}
            changePositionOnHover
          />
        </div>
      </div>
    </ModalDefault>
  );
};

export default CompareReportsModal;
